/**
 * Lead judgment service — thin wrapper over api/lead-judgment.js. Entirely Clerk-authed (no
 * public surface, unlike leadIntake.js). Backs the 5-axis "judgment layer" in
 * CrmLeadDetailModal.jsx and crmLeadNextStep.js — see docs/CRM.md's 2026-07 entries.
 */
async function clerkToken() {
  try { return typeof window.__clerkGetToken === 'function' ? await window.__clerkGetToken().catch(() => null) : null } catch { return null }
}

async function teamPost(body) {
  const token = await clerkToken()
  const res = await fetch('/api/lead-judgment', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify(body),
  })
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error || 'Request failed')
  return res.json()
}

export const FIT_RATING_OPTS = ['Poor Fit', 'Marginal Fit', 'Good Fit', 'Strong Fit', 'Excellent Fit']
export const LOW_FIT = new Set(['Poor Fit', 'Marginal Fit'])

export const NOT_CLIENT_TYPES = ['trade_or_referral_partner', 'vendor_or_consultant', 'other']
export const NOT_CLIENT_LABELS = {
  trade_or_referral_partner: 'Trade/referral partner',
  vendor_or_consultant: 'Vendor or consultant',
  other: 'Other',
}

const FIT_RATING_COLORS = {
  'Poor Fit': '#E24B4A', 'Marginal Fit': '#E24B4A',
  'Good Fit': '#BA7517', 'Strong Fit': '#1D9E75', 'Excellent Fit': '#1D9E75',
}
export function fitRatingColor(val) { return FIT_RATING_COLORS[val] || null }

/** Returns the judgment row for a lead, or null if none exists yet (the common case). */
export async function getLeadJudgment(leadId) {
  const res = await teamPost({ action: 'get', leadId })
  return (res && res.judgment) || null
}

/** Upserts a patch of judgment columns for a lead; returns the saved row. */
export async function upsertLeadJudgment(leadId, patch) {
  const res = await teamPost({ action: 'upsert', leadId, patch })
  return (res && res.judgment) || null
}
